import React, { useState } from 'react'
import { Button, Alert } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../Buttons'
import DisposalModal from './DisposalModal'
import ScanCodeData from './ScanCodeData'
import ScanCode from './ScanCode'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'

const StyledButtonsWrapper = styled.div`
    .btn {
        margin: 4px;
    }
    display: flex;
    width: 100%;
    justify-content: space-between;
    
    @media screen and (max-width: 767px) {
        flex-direction: column;
        width: 100%;
    }
`
const Disposal = (props) => {
    const { t, washStore } = props
    const [scanCodeObj, setScanCodeObj] = useState(null);
    const [openDisposalModal, setOpenDisposalModal] = useState(false)

    const handleCloseDisposalModal = async (disposed) => {
        setOpenDisposalModal(false)
        if (disposed) {
            handleOnReset()
        }
    }
    const disposeRFID = async () => {
        setOpenDisposalModal(true)
    }
    const handleOnReset = () => {
        setScanCodeObj(null)
    }

    const renderInputRFID = (
        <ScanCode scanCodeObj={scanCodeObj} setScanCodeObj={setScanCodeObj} />
    )
    const renderRFIDInfo = (
        <div>
            <h2>{t('washPage:discardArticle')}</h2>
            <ScanCodeData scanCodeObj={scanCodeObj} />
            <StyledButtonsWrapper>
                {washStore.checkWashActionIsAllowed('disposed') && <ButtonWithLoadingState
                    className='mb-2'
                    buttonText={t('washPage:discardArticle')}
                    onClick={disposeRFID}
                />}
                <Button className='mb-2' variant="secondary" onClick={handleOnReset}>{t('cancelButton')}</Button>
            </StyledButtonsWrapper>
        </div>
    )
    return (
        <>
            <h2>{t('washPage:disposed')}</h2>
            {(scanCodeObj && scanCodeObj.isValid) ? renderRFIDInfo : renderInputRFID}
            {washStore.createErrorCode(scanCodeObj) ? <Alert variant="danger">{washStore.createErrorCode(scanCodeObj)}</Alert> : null}
            {washStore.createInfoCode(scanCodeObj) ? <Alert variant="info">{washStore.createInfoCode(scanCodeObj)}</Alert> : null}
            {openDisposalModal ? (
                <DisposalModal
                    scanCodeObj={scanCodeObj}
                    handleClose={handleCloseDisposalModal}
                />
            ) : null}
        </>
    )
}

export default withTranslation()(
    inject(
        'washStore',
    )(observer(Disposal))
)
